module.exports = __webpack_public_path__ + "static/media/minus.8afd74b8.svg";